// extracted by mini-css-extract-plugin
module.exports = {"sideMove":"index_sideMove_3RW0i","sideWrapper":"index_sideWrapper_3qahh"};